import React, { useEffect } from "react";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

export default function Success() {
    const navigate = useNavigate();

    useEffect(() => {
        Swal.fire({
            title: 'Success!',
            text: 'Payment successful. Thank you for your payment!',
            icon: 'success',
            confirmButtonText: 'OK',
            // timer: 5000, // Auto-close after 3 seconds
            timerProgressBar: true, // Show a progress bar
            allowOutsideClick: true, // Allow closing by clicking outside
            allowEscapeKey: true, // Allow closing with Esc key
            allowEnterKey: true
        }).then(() => {
            // This will run whether the alert is closed by OK button, clicking outside, pressing Esc, or timer
            navigate('/'); // Redirect to home
        });
    }, [navigate]);

    return (
        <>
            {/* You can leave this empty or show a loading spinner */}
        </>
    );
}
